module.exports = __webpack_public_path__ + "static/media/reshot-icon-arrow-right.9465f1bd.svg";